import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchListFollowCommunityRequest,
  fetchListTrendingCommunityRequest,
  fetchListVideoCommunityRequest,
  resetListUserPosts,
} from "../store/actions";
import { useAppDispatch } from "core/hooks/useAppDispatch";

interface Filter {
  tab: "trending" | "follow" | "video";
  limit?: number;
  last_id?: string;
  cache_key?: string;
}

interface CommunityState {
  loading?: boolean;
  data?: any[];
  lastPage: number;
  params: any;
}

interface RootState {
  Community: Record<string, CommunityState>;
}

export const useGetCommunityList = (filter: Filter) => {
  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();
  const communityState = useSelector(
    (state: RootState) => state.Community || {}
  );
  const currentTab = filter?.tab;
  const isTrending = currentTab === "trending";
  const {
    loading = false,
    data = [],
    lastPage,
    params = {},
  } = communityState[currentTab] || {};

  const fetchActions: Record<string, any> = {
    trending: fetchListTrendingCommunityRequest,
    follow: fetchListFollowCommunityRequest,
    video: fetchListVideoCommunityRequest,
  };

  console.log(params, "params");

  const fetchData = (params: {
    page?: number;
    tab: string;
    limit?: number;
    last_id?: string;
    cache_key?: string;
  }) => {
    if (fetchActions[currentTab]) {
      const payload = isTrending
        ? {
            limit: params?.limit || 10,
            last_id: params?.last_id || null,
            cache_key: params?.cache_key || null,
          }
        : {
            page: params.page || 1,
            page_size: 10,
            order_by: "id",
            order_dir: "desc",
          };
      dispatch(fetchActions[currentTab](payload));
      dispatch(resetListUserPosts());
    }
  };

  const fetchDataInit = (params: {
    page?: number;
    tab: string;
    limit?: number;
    last_id?: string;
    cache_key?: string;
  }) => {
    if (fetchActions[currentTab]) {
      const payload = isTrending
        ? {
            limit: params?.limit || 10,
            last_id: params?.last_id || null,
            cache_key: params?.cache_key || null,
          }
        : {
            page: params.page || 1,
            page_size: 10,
            order_by: "id",
            order_dir: "desc",
          };
      appDispatch(fetchActions[currentTab](payload));
      dispatch(resetListUserPosts());
    }
  };

  useEffect(() => {
    fetchDataInit({ page: params.page, tab: currentTab, limit: params.limit });
  }, [currentTab]);

  const reLoadList = (params: { page: number; tab: string; limit?: number }) =>
    fetchData(params);

  const loadMore = useCallback(() => {
    if (!loading) {
      if (isTrending) {
        fetchData({
          tab: currentTab,
          limit: params?.limit || 5,
          last_id: params?.last_id || null,
          cache_key: params?.cache_key || null,
        });
      } else {
        fetchData({
          ...params,
          page: (params.page || 1) + 1,
          tab: currentTab,
        });
      }
    }
  }, [loading, params, currentTab]);

  return { loading, data, reLoadList, loadMore, lastPage, params };
};
